// extracted by mini-css-extract-plugin
module.exports = {"content":"KUwRz","content_borderTop":"dUHhp","content_indentTop":"_8S2NI","content_indentBottom":"cv15n","content_paddingXOff":"V4IIj","content_maximize":"q49l-"};